export default __webpack_public_path__ + "static/media/memberDark.14a809fe.svg";